import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchProductOffers'
})
export class SearchProductOffersPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) return [];
    if (!searchText) return items;
    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it.offer_type_name.toLowerCase().includes(searchText.toLowerCase());
    });
  }

}
